﻿package com.mgacreative.hotelru.feature.finance.di

import com.mgacreative.hotelru.feature.finance.ui.FinanceViewModel
import com.mgacreative.hotelru.feature.finance.ui.CashRegisterViewModel
import org.koin.core.module.dsl.viewModel
import org.koin.dsl.module

fun getFinanceFeatureModule() = module {
    viewModel { FinanceViewModel(get(), get(), null) }
    viewModel { CashRegisterViewModel(get()) }
}

